
const INITIAL_STATE = {}

const customerReducer = (state = INITIAL_STATE, action) => {
        switch (action.type) {
                case "GET_UF":
                        return { ...state, ListaTodosUF: action.payload.data }
                case "GET_CIDUF":
                        return { ...state, ListaTodosUFCid: action.payload.data }
                case "GET_ENDERECOS":
                        return { ...state, ListaTodosEnd: action.payload.data }
                case "GET_VENDEDORES":
                        return { ...state, ListaTodosVnd: action.payload.data }
                case "GET_TODOSCET":
                        return { ...state, ListaTodosCet: action.payload.data }
                case "GET_DATA_LSTRVD":
                        return { ...state, ListaTdsRevendas: action.payload.data }
                case "GET_DATA_DELIVERY":
                        return { ...state, DadosDelivery: action.payload.data }
                case "GET_DATA_FINANCIAL":
                        return { ...state, DadosFinancial: action.payload.data }
                case "GET_DATA_INFORMACOES":
                        return { ...state, DadosInformacoes: action.payload.data }
                case "GET_RECARREGA":
                        return { ...state, RecarregaInformacoes: action.payload }
                default:
                        return state
        }
}
export default customerReducer;
